import { IinterSupport } from './../../types';

import './style.less';

const Support: React.FC<IinterSupport> = props => {
    const { title, desc, title1, desc1, list } = props;

    return <div className='paddle-inter-support-wrapper' onMouseEnter={() => localStorage.setItem('powerStatus', 'outerTop')}>
        <div className='paddle-inter-support' >
            <div className='paddle-inter-support-title'>{ title }</div>
            <div className='paddle-inter-support-desc'>{ desc }</div>

            <div className='paddle-inter-support-card-wrapper'>
                {
                    list.map(item => <div className='paddle-inter-support-card' key={item.title} onClick={() => {window.open(item.link)}}>
                        <img className='paddle-inter-support-card-image' src={item.imageUrl} alt={item.title} />
                        <div className='paddle-inter-support-card-title'>{ item.title }</div>
                        <div className='paddle-inter-support-card-desc'>{ item.desc }</div>
                        <a className='paddle-inter-support-card-link' href={item.link} target="_blank" rel='noreferrer'>
                            Learn more <span className="paddle-inter-support-card-link-arrow"></span>
                        </a>
                    </div>)
                }
            </div>

            <div className='paddle-inter-support-title1'>{ title1 }</div>
            <div className='paddle-inter-support-desc1'>{ desc1 }</div>
            
        </div>
    </div>;
};

export default Support;